import { toLocalDateString } from "./dateHelpers";

/**
 * Phrase du jour déterministe pour une page (même logique que PageTagline).
 * @param {string[]} phrases
 * @param {string} [pageId]
 */
export function pickDailyPhrase(phrases, pageId = "default") {
  if (!Array.isArray(phrases) || phrases.length === 0) return "";
  const today = toLocalDateString();
  const seed = `${today}|${pageId}`;
  let h = 0;
  for (let i = 0; i < seed.length; i++) {
    h = (h * 31 + seed.charCodeAt(i)) | 0;
  }
  return phrases[Math.abs(h) % phrases.length];
}
